module.exports = __webpack_public_path__ + "img/khb.a864a478.svg";